import React, { useEffect } from 'react';
import { getBrandName, getZapierKnowledgeBaseUrl } from '../utils/brand';

const ZapierReference = () => {
    const brandName = getBrandName();
    const knowledgeBaseUrl = getZapierKnowledgeBaseUrl();
    const ZAPIER_URL = `${window.location.protocol}//${window.location.host}/zapier.html`;

    useEffect(() => {
        document.title = `Zapier · ${brandName} Docs`;
    }, [brandName]);

    return (
        <div className="swagger-ui doc-page doc-page--full">
            <div className="information-container wrapper">
                <div className="info">
                    <h2 className="title">Zapier</h2>
                    <h2>Overview</h2>
                    <p>
                        Zapier connects {brandName} to 1000+ of your favorite apps so you can automate repetitive tasks without leaving {brandName}.
                    </p>
                    <p>
                        <a className="link" rel="noopener noreferrer" target="_self" href={knowledgeBaseUrl}>Learn more about Zapier...</a>
                    </p>
                </div>
                <iframe title="Zapier" frameBorder={0} src={ZAPIER_URL} />
            </div>
        </div>
    );
}

export default ZapierReference;